import {Component, Input} from '@angular/core';
import {CommonModule} from "@angular/common";
import {
  ServiceFindByIdContainerComponent
} from "../../../../../core/component/service-find-by-id-container/service-find-by-id-container.component";
import {DocumentSummaryFindOneByIdService} from "../../service/documentSummaryFindOneById.service";
import {
  FormArrayInputModule
} from "../../../../../../components/common/form-array/form-array-input/form-array-input.module";
import {DocumentSummaryModelFieldModule} from "../document-summary-field/document-summary-field.module";

@Component({
  selector: 'app-document-summary-field-by-id',
  templateUrl: './document-summary-field-by-id.component.html',
  standalone: true,
  imports: [
    CommonModule,
    ServiceFindByIdContainerComponent,
    FormArrayInputModule,
    DocumentSummaryModelFieldModule,
  ],
  providers: [DocumentSummaryFindOneByIdService]
})
export class DocumentSummaryFieldByIdComponent {

  @Input() id: number;

  constructor(public service: DocumentSummaryFindOneByIdService) {
  }
}
